import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';

import {
    deleteMsg,
    error,
    NO_DATA_FOUND,
    saveMsg,
    selectOption,
    success, warning
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {
    ButtonAdd2,
    ButtonCancel2,
    ButtonTableDelete
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import {productProvider} from "../../../providers/productProvider";
import {productPromotionService} from "../../../jwt/_services/promotions/productPromotionService";
import BootstrapTable from "react-bootstrap-table-next";
import SelectGeneric from "../../../components/select/selectGeneric";

export const ProductPromotionPackageModal = forwardRef((props, ref) => {

    // Form const
    const [loading, setLoading] = useState(false);
    const [productPromotion, setProductPromotion] = useState(props.productPromotion);
    const [modal, setModal] = useState(false);

    // Multiproduct const
    const [listItems, setListItems] = useState([]);
    const [productId, setProductId] = useState(null);

    useEffect(() => {
        setProductPromotion(props.productPromotion);
        refreshDataList(props.productPromotion);
    }, []);

    const refreshDataList = (_productPromotion) => {
        if (!_productPromotion){
            return;
        }

        setLoading(true);
        const productPromotion = {
            id : _productPromotion.PPId
        }

        productPromotionService.listChilds(productPromotion)
            .then(result => {
                if (result){
                    setListItems(result);
                } else {
                    setListItems([]);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                showToastCustom(error, errorMessage);
            });
    }

    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(_productPromotion) {
            setModal(!modal);
            setProductPromotion(_productPromotion);
            refreshDataList(_productPromotion);
        }
    }));

    // ----------------------------------------------
    //            ADD/REMOVE CHILDS
    // ----------------------------------------------
    const removeChild = (data) => {
        setLoading(true);
        const multiProduct = {
            productPromotion : { id : productPromotion.PPId },
            product : { id : data.id }
        }
        productPromotionService.removeChild(multiProduct)
            .then(_ => {
                showToastCustom(warning, deleteMsg, true);
                refreshDataList(productPromotion);
            });
    }

    const addChild = () => {
        if (productId === null || productId === undefined || productId === '') {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const multiProduct = {
            productPromotion : { id : productPromotion.PPId },
            product : { id : productId }
        }
        productPromotionService.addChild(multiProduct)
            .then(_ => {
                showToastCustom(success, saveMsg);
                refreshDataList(productPromotion);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => removeChild(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'sivexCode',
        text: 'Codigo Sivex',
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '80px'},
        formatter: actionsFormatter
    }];

    return (
        <Modal
            isOpen={modal}
            toggle={showModal}
        >
            <ModalHeader toggle={showModal}>
                <i className="fas fa-box-open mr-2"/>
                Paquete
            </ModalHeader>
            <ModalBody  >
                <Card>
                    {loading && showLoader()}
                    <CardBody>
                        <Form >
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Producto</Label>
                                        <SelectGeneric
                                            initialValue={ productId }
                                            setExternalValue={ setProductId }
                                            provider = { productProvider }
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <CardBody className="border-top">
                                <div className="float-right">
                                    <ButtonAdd2 onClick={addChild}/>
                                    <ButtonCancel2 onClick={showModal}/>
                                </div>
                            </CardBody>
                        </Form>
                    </CardBody>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-box-open mr-2"/>
                        Productos del paquete
                    </CardTitle>
                    <CardBody className="border-top">
                        <BootstrapTable
                            striped hover
                            tableHeaderClass='mb-0'
                            remote
                            keyField="id"
                            data={listItems}
                            noDataIndication={NO_DATA_FOUND}
                            columns={columns}
                        />
                    </CardBody>
                </Card>

            </ModalBody>
        </Modal>
    )
})